export const guideVideoType = [
  '找到我们',
  '开户充值',
  '查找信息',
  '快速收客',
  '极速办理',
  '出签进度',
  '产品营销',
];

export const visaOpenClassType = [
  '欧洲申根签',
  '北美洲签证',
  '亚洲签证',
  '大洋洲签证',
  '签证业务',
];



// WEBPACK FOOTER //
// ./src/constants/knowledge-constants.js